import React, { useEffect, useState } from 'react';
import { isSafeToReload, reloadToLatest, startUpdateWatcher } from '../utils/appUpdate';

// 새 버전이 배포되면 상단에 안내. 입력 중인 내용이 없어지면 잠시 후 자동으로 적용한다.
export function UpdateBanner() {
    const [available, setAvailable] = useState(false);

    useEffect(() => startUpdateWatcher(() => setAvailable(true)), []);

    useEffect(() => {
        if (!available) return undefined;
        const timer = setInterval(() => { if (document.visibilityState === 'hidden' && isSafeToReload()) reloadToLatest(); }, 15000);
        return () => clearInterval(timer);
    }, [available]);

    if (!available) return null;
    return (
        <div className="update-banner" role="status">
            <span>🎉 새 버전이 있습니다</span>
            <button onClick={reloadToLatest}>지금 업데이트</button>
        </div>
    );
}
